import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { useEstoquesMedicamentoState } from "../context/estoques-medicamento-context";
import { useEstoquesMedicamentoController } from "../context/estoques-medicamento-controller";
import { EstoqueMedicamentoForm } from "./estoque-medicamento-form";

export const EstoqueMedicamentoDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = useEstoquesMedicamentoController();
    const { dataResponse, showAddEdit } = useEstoquesMedicamentoState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Registro de Estoque ${dataResponse?.id}`;
        return "Adicionar Registro de Estoque";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <EstoqueMedicamentoForm />
        </DefaultDrawer>
    );
};
